"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportManufacturingFilesConfig = void 0;
const zod_1 = require("zod");
exports.ExportManufacturingFilesConfig = zod_1.z.enum(["off", "on", "control", "expertReview", "checkReviewTab"]);
//# sourceMappingURL=exportManufacturingFiles.js.map